import React from "react"
import {connectSearchBox} from "react-instantsearch-dom"
import {Search as SearchIcon} from "@styled-icons/fa-solid"

function debouncePromise(fn, time) {
  let timerId = undefined
  return function debounced(...args) {
    if (timerId) {
      clearTimeout(timerId)
    }
    return new Promise((resolve) => {
      timerId = setTimeout(() => resolve(fn(...args)), time)
    })
  }
}

export default connectSearchBox(
  ({refine, className, onFocus}) => {
    const debouncedSearch = debouncePromise(e => refine(e.target.value), 1000)

    const onChange = e => {
      e.persist()
      if (e.target.value) {
        debouncedSearch(e, e.eventTarget)
      }
    }

    const onSubmit = e => {
      e.preventDefault()
    }

    return (
      <form className={className} onSubmit={onSubmit}>
        <input
          id="searchInput"
          className="SearchInput"
          type="text"
          placeholder="Rechercher"
          aria-label="Rechercher"
          onChange={onChange}
          onFocus={onFocus}
        />
        <SearchIcon className="SearchIcon"/>
      </form>
    )
  })

